<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">样本册名称：</div>
            <div class="search-form-controller">
              <el-input size="mini" placeholder="样本册名称" clearable v-model="queryData.product_name"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">外协商：</div>
            <div class="search-form-controller">
              <el-input size="mini" placeholder="外协商" clearable v-model="queryData.company_name"></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="search-form-label">送货日期:</div>
            <div class="search-form-controller">
              <el-date-picker style="width: 42%" type="date" size="mini" placeholder="开始日期" v-model="queryData.startDate" value-format="yyyy-MM-dd"></el-date-picker>
              <span style="width: 2%">-</span>
              <el-date-picker style="width: 42%" type="date" size="mini" placeholder="结束日期" v-model="queryData.endDate" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button type="warning" size="mini" icon="el-icon-search" plain @click="searchHandler">开始搜索</el-button>
            <el-button type="primary" size="mini" icon="el-icon-delete" plain @click="searchHandler('clear')">清空</el-button>
            <el-button type="danger" size="mini" icon="el-icon-close" plain @click="showSearchHandler()">关闭搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button v-for="btn in $store.state.currentLBtnList" :key="btn.id" :type="btn.button_type" size="mini" :icon="btn.button_icon" @click="handlerButtonDispatch(btn.fn)">{{btn.button_name}}</el-button>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table :data="ds" size="mini" stripe border height="100%" style="width: 100% border:1px solid #d1d1d1" header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler">
          <el-table-column v-if="outsource_company_id !== '0'" type="selection" width="40" align="center" :selectable="selectableHandler"></el-table-column>
          <el-table-column label="送货日期" prop="delivery_date" width="120" align="center"></el-table-column>
          <el-table-column label="送货单号" prop="delivery_no" width="100" align="center"></el-table-column>
          <el-table-column label="样本册名称" prop="product_name" width="100" align="center"></el-table-column>
          <el-table-column label="外协商" prop="company_name" width="200" align="center"></el-table-column>
          <el-table-column label="送货人" prop="delivery_person" width="80" align="center"></el-table-column>
          <el-table-column label="备注" prop="remark" align="center"></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-view" circle plain @click.stop.prevent="viewHandler(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination background :current-page="queryData.pn" :page-size="queryData.pageSize" :total="queryData.totalCount" :page-sizes="[10, 15, 20, 25, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChange" @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
    <!-- 新增表单对话框 -->
    <send-dialog-form ref="DForm" :parent="this" />
  </div>
</template>

<script>
import SendDialogForm from '@/views/modules/delivery/Form'
export default {
  data: function () {
    return {
      ds: [],
      selectedIds: [],
      // 分页
      queryData: {
        outsource_company_id: '',
        product_name: '',
        company_name: '',
        startDate: '',
        endDate: '',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem('operator_id'),
      outsource_company_id: sessionStorage.getItem('outsource_company_id')
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function (fn, args) {
      var _this = this
      if (typeof _this[fn] === 'function') {
        _this[fn].apply(_this, args)
      } else {
        console.log('warning: the method is not exist')
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.queryData.outsource_company_id = _this.outsource_company_id
      _this.post(_this.$apis.getSendOrderList, _this.queryData, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.ds = _json.datalist
          _this.queryData.totalCount = _json.totalCount
        }
      })
    },
    // 多选事件
    selectHandler: function (selection) {
      this.selectedIds = []
      for (let i = 0; i < selection.length; ++i) {
        this.selectedIds.push(selection[i].id)
      }
    },
    // 新增
    addHandler: function () {
      this.$refs.DForm.addHandler()
    },
    // 删除
    delHandler: function () {
      let _this = this
      let _ids = _this.selectedIds.join(',')

      if (_ids.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let _params = {
            ids: _ids,
            operator_id: _this.operator_id
          }
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delSendOrderList, _params, function (res) {
            let _json = res.data
            if (_json.status && _json.status === 'logout') {
              _this.logout()
            } else {
              if (_json.status === 'ok') {
                _this.loadData()
                _this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
                _this.$message({
                  type: 'error',
                  message: '无数据更新!'
                })
              }
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 浏览
    viewHandler: function (_row) {
      let formId = _row.id
      this.$refs.DForm.viewHandler(formId)
    },
    searchHandler: function (_type) {
      this.queryData.pn = 1;
      if (_type === 'clear') {
        this.queryData.product_name = ''
        this.queryData.company_name = ''
        this.queryData.startDate = ''
        this.queryData.endDate = ''
      }
      this.loadData()
    },
    showSearchHandler: function () {
      this.searchShow = !this.searchShow
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadData()
    },
    // 页码改变
    pageSizeChange: function (pageSize) {
      this.queryData.pn = 1
      this.queryData.pageSize = pageSize
      this.loadData()
    },
    pageChange: function (pn) {
      this.queryData.pn = pn
      this.loadData()
    },
    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function (_row, _index) {
      return true
    }
  },
  components: {
    SendDialogForm
  }
}
</script>
